import React, {Suspense} from "react";
import Loader from "../loader/loader";
import Button from "../button/button";
import "./pdfLink.scss";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../models/httpError";
import {Api} from "../../../../helpers/api";
import i18n from "../../../../i18n/i18n";
import {Tooltip} from "@mui/material";

interface PdfLink {
    fileName: string;
    document: React.ReactElement;
    buttonText: string;
    buttonVariant: "contained" | "outlined";
    endIcon: JSX.Element;
    responseFile?: AxiosResponse<HttpErrorModel[] | any> | undefined;
    disabed?: boolean | false;
    testId?: string;
}

export default function PdfLink(props: PdfLink): React.ReactElement {
    const PdfLinkContent = React.lazy(() => import ("./pdfLinkContent"));

    if (!Api.isSuccess(props.responseFile) || props.disabed) {
        return (
            <Tooltip title={`${i18n.t("documents.generalDeclaration.details.files.failedGenerate")}`} arrow>
                <div className={`pdf-link ${Api.isSuccess(props.responseFile) ? "" : "disabled"}`}>
                    <Button
                        type="primary"
                        text={props.buttonText}
                        endIcon={props.endIcon}
                        disabled
                        testId={props.testId}
                    />
                </div>
            </Tooltip>
        );
    } else {
        return (
            <div className="pdf-link">
                <Suspense fallback={
                    <Button
                        type="primary"
                        text={props.buttonText}
                        endIcon={<Loader/>}
                        variant={props.buttonVariant}
                        className={props.buttonVariant}
                        testId={props.testId}
                    />
                }>
                    <PdfLinkContent
                        fileName={props.fileName}
                        document={props.document}
                        buttonText={props.buttonText}
                        buttonVariant={props.buttonVariant}
                        endIcon={props.endIcon}
                    />
                </Suspense>
            </div>
        );
    }
}
